import ReactDOM from 'react-dom';
import React from 'react';

import BoardContainer from 'Components/AppComponents/Board/BoardContainer/BoardContainer';

ReactDOM.render(
    <React.StrictMode>
        <div className="h-full flex">
            <div className="m-auto" id="full-game-container" style={{transformOrigin: 'top'}}>
                <div
                    className="text-center game-title w-full py-2"
                    style={{
                        color: 'white',
                        backgroundColor: 'rgba(58,58,58,0.7)',
                        textShadow: 'black 0px 10px 5px'
                    }}
                >
                    Power Grid Protector
                </div>
                <div className="flex overflow-hidden">
                    <BoardContainer />
                </div>
            </div>
        </div>
    </React.StrictMode>,
    document.getElementById('root')
);
